// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var AIAnswerBodyWrapper = styled.div(function (props) {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: props.isReadingAids ? "var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-300, 24px)", " ", "var(--ds-space-050, 4px)") : "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-300, 24px)", " 0px ", "var(--ds-space-300, 24px)")
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerErrorWrapper = styled.div({
  paddingRight: "var(--ds-space-300, 24px)"
});